module.exports = __webpack_public_path__ + "img/rx-dm0max-green.91f01a0c.png";